/* ─────────────────────────────────────────────
   Loop Lab Shopify Theme — Main JavaScript
   ───────────────────────────────────────────── */

/* === NAVBAR === */
(function () {
  const toggle = document.getElementById('menu-toggle');
  const menu = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    toggle.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open);
  });
  // Close on nav link click
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
    menu.classList.remove('open');
    toggle.classList.remove('open');
  }));
})();

/* === CART STATE === */
const LoopCart = {
  count: 0,

  async fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async addItem(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!res.ok) throw new Error('Failed to add item');
    return res.json();
  },

  async updateItem(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    return res.json();
  },

  async removeItem(lineKey) {
    return this.updateItem(lineKey, 0);
  },

  formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  },

  async refreshCount() {
    const cart = await this.fetchCart();
    this.count = cart.item_count;
    this.updateCountBadge(cart.item_count);
    return cart;
  },

  updateCountBadge(count) {
    const badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  },
};

/* === CART DRAWER === */
(function () {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  const openBtn = document.getElementById('cart-toggle');
  const closeBtn = document.getElementById('cart-close');
  const body = document.getElementById('cart-body');
  const footer = document.getElementById('cart-footer');
  const totalEl = document.getElementById('cart-total-price');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('open');
    drawer.removeAttribute('inert');
    overlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('inert', '');
    overlay.classList.remove('visible');
    document.body.style.overflow = '';
  }

  openBtn && openBtn.addEventListener('click', openDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // Listen for custom event from ATC buttons
  document.addEventListener('cart:open', openDrawer);

  async function renderCart() {
    const cart = await LoopCart.fetchCart();
    LoopCart.updateCountBadge(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p>Your cart is empty</p>
        </div>`;
      footer.style.display = 'none';
      return;
    }

    footer.style.display = 'flex';
    totalEl.textContent = LoopCart.formatMoney(cart.total_price);

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}
        </div>
        <div class="cart-item__info">
          <p class="cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <p class="cart-item__price">${LoopCart.formatMoney(item.final_price)}</p>
        </div>
        <div class="cart-item__actions">
          <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove item">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
          </button>
          <div class="cart-item__qty">
            <button class="cart-item__qty-btn" data-key="${item.key}" data-action="dec">−</button>
            <span class="cart-item__qty-num">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-key="${item.key}" data-action="inc">+</button>
          </div>
        </div>
      </div>`).join('');

    // Remove buttons
    body.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        await LoopCart.removeItem(btn.dataset.key);
        renderCart();
      });
    });

    // Qty buttons
    body.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const item = cart.items.find(i => i.key === btn.dataset.key);
        if (!item) return;
        const newQty = btn.dataset.action === 'inc' ? item.quantity + 1 : item.quantity - 1;
        await LoopCart.updateItem(btn.dataset.key, newQty);
        renderCart();
      });
    });
  }

  // Init count on load
  LoopCart.refreshCount();
})();

/* === ATC BUTTON (Collection & Homepage) === */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('[data-atc]');
  if (!btn) return;
  const variantId = btn.dataset.variantId;
  if (!variantId) return;
  btn.disabled = true;
  const original = btn.innerHTML;
  btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
  try {
    await LoopCart.addItem(variantId, 1);
    await LoopCart.refreshCount();
    document.dispatchEvent(new Event('cart:open'));
  } catch (err) {
    console.error('ATC error', err);
    btn.innerHTML = original;
    btn.disabled = false;
  }
  setTimeout(() => {
    btn.innerHTML = original;
    btn.disabled = false;
  }, 1800);
});

/* === REVIEW CAROUSEL === */
(function () {
  const section = document.getElementById('review-carousel');
  if (!section) return;

  const reviews = [
    { name: 'Ananya', rating: 5, text: 'Switched to Loop Lab two months ago and my hair fall has visibly reduced. The silk feels so gentle — I didn\'t realise how much damage my old elastic was doing until I stopped using it.' },
    { name: 'Ishaan', rating: 4, text: 'Bought the set of 3 as a gift for my sister and ended up stealing one for myself. The quality is genuinely impressive and it holds through the whole day without slipping.' },
    { name: 'Kavya', rating: 5, text: 'I have really fine hair and regular scrunchies would always leave a crease or pull a few strands out. Loop Lab is the first one that hasn\'t done either. Never going back.' },
    { name: 'Arjun', rating: 4, text: 'Picked this up for my wife and she\'s obsessed. She says her hair feels softer since she started using it — I\'ll take her word for it, but the packaging alone felt premium.' },
    { name: 'Meera', rating: 5, text: 'The difference is real. My hairdresser actually noticed less breakage at my last appointment and asked what I\'d changed. Told her — Loop Lab.' },
    { name: 'Rhea', rating: 4, text: 'Looks beautiful, feels luxurious, and actually stays in place. I was skeptical about silk scrunchies before this but the quality completely won me over.' },
    { name: 'Vihaan', rating: 5, text: 'Ordered the Work Week bundle and use a different one every day. No dents, no damage, no drama. Worth every rupee.' },
    { name: 'Diya', rating: 4, text: 'Been using it for three weeks and my ponytail doesn\'t have that harsh indent anymore. Small thing but it makes a big difference when you\'re taking your hair down at the end of the day.' },
    { name: 'Kabir', rating: 5, text: 'Gifted this to my mother who has been complaining about hair thinning. She messaged me the next morning to say it felt completely different. That says it all.' },
    { name: 'Priya', rating: 4, text: 'The silk is so soft I was worried it wouldn\'t hold, but it\'s been through gym sessions and long days without budging. Genuinely impressed.' },
  ];

  const card = section.querySelector('.review-card');
  const dotsWrap = section.querySelector('.review-dots');
  if (!card || !dotsWrap) return;

  let current = 0;
  let timer;

  function starSVG(filled) {
    return `<svg viewBox="0 0 24 24" fill="${filled ? '#F5A623' : 'none'}" stroke="#F5A623" stroke-width="${filled ? 0 : 1.5}"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
  }

  function renderDots() {
    dotsWrap.innerHTML = reviews.map((_, i) =>
      `<button class="review-dot${i === current ? ' active' : ''}" data-idx="${i}" aria-label="Review ${i + 1}"></button>`
    ).join('');
    dotsWrap.querySelectorAll('.review-dot').forEach(btn => {
      btn.addEventListener('click', () => goTo(parseInt(btn.dataset.idx)));
    });
  }

  function renderCard(r) {
    card.innerHTML = `
      <div class="review-stars">${Array.from({ length: 5 }).map((_, i) => starSVG(i < r.rating)).join('')}</div>
      <p class="review-text">"${r.text}"</p>
      <p class="review-author">— ${r.name}</p>`;
  }

  function goTo(idx) {
    card.classList.add('fading');
    setTimeout(() => {
      current = (idx + reviews.length) % reviews.length;
      renderCard(reviews[current]);
      card.classList.remove('fading');
      renderDots();
    }, 500);
    clearInterval(timer);
    timer = setInterval(advance, 4000);
  }

  function advance() { goTo(current + 1); }

  renderCard(reviews[0]);
  renderDots();
  timer = setInterval(advance, 4000);
})();

/* === SHOP COLLECTION SCROLL DOTS === */
(function () {
  const track = document.getElementById('shop-collection-track');
  const dotsWrap = document.getElementById('shop-dots');
  if (!track || !dotsWrap) return;

  function updateDots() {
    const cardW = 170 + 12;
    const idx = Math.round(track.scrollLeft / cardW);
    dotsWrap.querySelectorAll('.scroll-dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === idx);
    });
  }

  track.addEventListener('scroll', updateDots, { passive: true });
})();

/* === FAQ ACCORDION === */
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const wasOpen = item.classList.contains('open');
    // Close all
    document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });
});

/* === PDP GALLERY === */
(function () {
  const track = document.getElementById('pdp-img-track');
  const thumbs = document.querySelectorAll('.pdp-thumb');
  if (!track) return;

  // Thumb click → scroll track to that slide
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const idx = parseInt(thumb.dataset.index, 10);
      track.scrollTo({ left: track.offsetWidth * idx, behavior: 'smooth' });
    });
  });

  // Track scroll → sync active thumb
  track.addEventListener('scroll', () => {
    const idx = Math.round(track.scrollLeft / track.offsetWidth);
    thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
  }, { passive: true });
})();

/* === PDP VARIANT PICKER === */
(function () {
  const form = document.getElementById('pdp-form');
  if (!form) return;

  const pills = form.querySelectorAll('.pdp-pill');
  const swatches = form.querySelectorAll('.pdp-swatch');
  const priceEl = document.getElementById('pdp-price');
  const compareEl = document.getElementById('pdp-compare');
  const discountEl = document.getElementById('pdp-discount');
  const atcBtn = document.getElementById('pdp-atc-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const variantInput = form.querySelector('[name="id"]');

  // Combine pills and swatches into unified variant selector
  [...pills, ...swatches].forEach(el => {
    el.addEventListener('click', () => {
      const variantId = el.dataset.variantId;
      const price = parseInt(el.dataset.price);
      const compare = parseInt(el.dataset.compare || '0');
      const available = el.dataset.available === 'true';

      // Update active state in same group
      const group = el.closest('.pdp-option-group');
      if (group) {
        group.querySelectorAll('.pdp-pill, .pdp-swatch').forEach(s => s.classList.remove('active'));
      }
      el.classList.add('active');

      // Update variant input
      if (variantInput) variantInput.value = variantId;

      // Update price display
      if (priceEl) priceEl.textContent = '₹' + (price / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
      if (compareEl && compare > price) {
        compareEl.textContent = '₹' + (compare / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
        compareEl.style.display = '';
        const pct = Math.round(((compare - price) / compare) * 100);
        if (discountEl) { discountEl.textContent = pct + '% OFF'; discountEl.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (discountEl) discountEl.style.display = 'none';
      }

      // Update ATC state
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
        atcBtn.classList.toggle('sold-out', !available);
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });
})();

/* === PDP QUANTITY === */
(function () {
  const decBtn = document.getElementById('qty-dec');
  const incBtn = document.getElementById('qty-inc');
  const numEl = document.getElementById('qty-num');
  const qtyInput = document.querySelector('[name="quantity"]');
  if (!decBtn || !incBtn || !numEl) return;
  let qty = 1;

  function setQty(n) {
    qty = Math.max(1, n);
    numEl.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }

  decBtn.addEventListener('click', () => setQty(qty - 1));
  incBtn.addEventListener('click', () => setQty(qty + 1));
})();

/* === PDP ATC === */
(function () {
  const form = document.getElementById('pdp-form');
  const atcBtn = document.getElementById('pdp-atc-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (!form) return;

  async function handleATC(e) {
    e.preventDefault();
    const variantId = form.querySelector('[name="id"]')?.value;
    const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1');
    if (!variantId) return;

    const btns = [atcBtn, stickyBtn].filter(Boolean);
    btns.forEach(b => { b.disabled = true; b.textContent = 'Adding…'; });

    try {
      await LoopCart.addItem(variantId, quantity);
      await LoopCart.refreshCount();
      btns.forEach(b => { b.textContent = 'Added ✓'; });
      setTimeout(() => {
        btns.forEach(b => { b.disabled = false; b.textContent = 'Add to Cart'; });
        document.dispatchEvent(new Event('cart:open'));
      }, 1000);
    } catch (err) {
      btns.forEach(b => { b.disabled = false; b.textContent = 'Add to Cart'; });
    }
  }

  atcBtn && atcBtn.addEventListener('click', handleATC);
  stickyBtn && stickyBtn.addEventListener('click', handleATC);
})();

/* === STICKY ATC VISIBILITY === */
(function () {
  const stickyBar = document.getElementById('sticky-atc');
  const mainAtc = document.getElementById('pdp-atc-btn');
  if (!stickyBar || !mainAtc) return;

  const obs = new IntersectionObserver(([entry]) => {
    stickyBar.classList.toggle('hidden', entry.isIntersecting);
  }, { threshold: 0.1 });
  obs.observe(mainAtc);
})();

/* === COLLECTION FILTERS === */
(function () {
  const filterBtn = document.getElementById('filter-btn');
  const filterSheet = document.getElementById('filter-sheet');
  const filterOverlay = document.getElementById('filter-overlay');
  const filterClose = document.getElementById('filter-close');
  const filterClear = document.getElementById('filter-clear');
  const filterApply = document.getElementById('filter-apply');
  if (!filterBtn || !filterSheet) return;

  function openSheet() {
    filterSheet.classList.add('open');
    filterOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() {
    filterSheet.classList.remove('open');
    filterOverlay.classList.remove('visible');
    document.body.style.overflow = '';
  }

  filterBtn.addEventListener('click', openSheet);
  filterClose && filterClose.addEventListener('click', closeSheet);
  filterOverlay && filterOverlay.addEventListener('click', closeSheet);
  filterClear && filterClear.addEventListener('click', () => {
    filterSheet.querySelectorAll('.filter-chip.active').forEach(c => c.classList.remove('active'));
  });
  filterApply && filterApply.addEventListener('click', closeSheet);

  // Chip toggles
  filterSheet && filterSheet.querySelectorAll('.filter-chip').forEach(chip => {
    chip.addEventListener('click', () => chip.classList.toggle('active'));
  });
})();

/* === SORT DROPDOWN === */
(function () {
  const sortBtn = document.getElementById('sort-btn');
  const sortDrop = document.getElementById('sort-dropdown');
  if (!sortBtn || !sortDrop) return;

  sortBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    sortDrop.classList.toggle('open');
  });
  document.addEventListener('click', () => sortDrop.classList.remove('open'));

  sortDrop.querySelectorAll('.sort-option').forEach(opt => {
    opt.addEventListener('click', () => {
      sortDrop.querySelectorAll('.sort-option').forEach(o => o.classList.remove('active'));
      opt.classList.add('active');
      sortBtn.querySelector('span').textContent = 'Sort: ' + opt.textContent;
      sortDrop.classList.remove('open');
      // Trigger URL sort param
      const url = new URL(window.location);
      url.searchParams.set('sort_by', opt.dataset.sort);
      window.location = url.toString();
    });
  });
})();

/* === HASH SCROLL (Contact Us → #faqs) === */
document.querySelectorAll('a[href^="/#"]').forEach(a => {
  a.addEventListener('click', e => {
    if (window.location.pathname !== '/') return;
    e.preventDefault();
    const id = a.hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
